import React from 'react';
import { Spin } from 'antd';

const loading = <Spin tip="Loading..." />;

export default loading;
